import styled from "styled-components";

export const ErrorPageContainer = styled.div`
  /* max-height: calc(100vh - 61px); */
  height:100%;
  width:100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
  background-color: #fff;
  img {
    position: fixed;
    overflow: hidden;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    z-index: -1;
  }
  .error__image {
    max-height: 450px;
    width: 100%;
    margin-bottom: 10px;
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    @media screen and (max-width: 768px) {
      max-height: 300px;
    }
  }
  .error__title {
    margin-top: 10px;
    padding: 30px 0 50px;
    text-align: center;
  }
  .common__button {
    border: none;
    padding: 8px 40px;
    border-radius: 18.5px;
    width: 267px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #00a4e5;
    font-size: 16px;
    font-weight: 400;
    color: #fcfcfc;
    outline: none;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;
